import { baseQuery } from "src/store/helpers/baseQuery";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient, { type ClientsApiForFeatureUpdate } from "./rtkClient";

const clientsApiForFeature: { current: ClientsApiForFeatureUpdate | null } = { current: null };

export const clientsApi = createApi({
    reducerPath: "clientsApi",
    tagTypes: ["Clients", "ClientDetails", "ClientFeatures"],
    keepUnusedDataFor: 300,
    baseQuery,
    endpoints: (builder) => ({
        getClients: rtkClient.getClients(builder),
        getClient: rtkClient.getClient(builder),
        getClientFeatures: rtkClient.getClientFeatures(builder),
        createClient: rtkClient.createClient(builder),
        updateClientMembers: rtkClient.updateClientMembers(builder),
        updateClientExpiration: rtkClient.updateClientExpiration(builder),
        cancelClientSubscription: rtkClient.cancelClientSubscription(builder),
        reviveClientSubscription: rtkClient.reviveClientSubscription(builder),
        updateClientFeature: rtkClient.updateClientFeature(builder, () => clientsApiForFeature.current!),
        updateClientWorkspace: rtkClient.updateClientWorkspace(builder),
    }),
});
clientsApiForFeature.current = clientsApi as ClientsApiForFeatureUpdate;

export const {
    useGetClientsQuery,
    useGetClientQuery,
    useGetClientFeaturesQuery,
    useCreateClientMutation,
    useUpdateClientMembersMutation,
    useUpdateClientExpirationMutation,
    useCancelClientSubscriptionMutation,
    useReviveClientSubscriptionMutation,
    useUpdateClientFeatureMutation,
    useUpdateClientWorkspaceMutation,
} = clientsApi;
